import { RoleModuleConfig } from './types';


export const userModules: RoleModuleConfig = {
  slices: [],
  sagas: {},
};
